/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestFeedbackExportPost } from '../fn/feedback/api-request-feedback-export-post';
import { ApiRequestFeedbackExportPost$Params } from '../fn/feedback/api-request-feedback-export-post';
import { apiRequestFeedbackGetAllFeedbackRequestPost } from '../fn/feedback/api-request-feedback-get-all-feedback-request-post';
import { ApiRequestFeedbackGetAllFeedbackRequestPost$Params } from '../fn/feedback/api-request-feedback-get-all-feedback-request-post';
import { apiRequestFeedbackGetFeedbackGet } from '../fn/feedback/api-request-feedback-get-feedback-get';
import { ApiRequestFeedbackGetFeedbackGet$Params } from '../fn/feedback/api-request-feedback-get-feedback-get';
import { apiRequestFeedbackSavePost } from '../fn/feedback/api-request-feedback-save-post';
import { ApiRequestFeedbackSavePost$Params } from '../fn/feedback/api-request-feedback-save-post';
import { Feedback } from '../models/feedback';
import { FeedbackApiRespModel } from '../models/feedback-api-resp-model';
import { FeedbackDashboardResult } from '../models/feedback-dashboard-result';

@Injectable({ providedIn: 'root' })
export class FeedbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestFeedbackGetAllFeedbackRequestPost()` */
  static readonly ApiRequestFeedbackGetAllFeedbackRequestPostPath = '/api/request/feedback/GetAllFeedbackRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestFeedbackGetAllFeedbackRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackGetAllFeedbackRequestPost$Response(params?: ApiRequestFeedbackGetAllFeedbackRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackDashboardResult>> {
    return apiRequestFeedbackGetAllFeedbackRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestFeedbackGetAllFeedbackRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackGetAllFeedbackRequestPost(params?: ApiRequestFeedbackGetAllFeedbackRequestPost$Params, context?: HttpContext): Observable<FeedbackDashboardResult> {
    return this.apiRequestFeedbackGetAllFeedbackRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackDashboardResult>): FeedbackDashboardResult => r.body)
    );
  }

  /** Path part for operation `apiRequestFeedbackExportPost()` */
  static readonly ApiRequestFeedbackExportPostPath = '/api/request/feedback/Export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestFeedbackExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackExportPost$Response(params?: ApiRequestFeedbackExportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRequestFeedbackExportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestFeedbackExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackExportPost(params?: ApiRequestFeedbackExportPost$Params, context?: HttpContext): Observable<string> {
    return this.apiRequestFeedbackExportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRequestFeedbackGetFeedbackGet()` */
  static readonly ApiRequestFeedbackGetFeedbackGetPath = '/api/request/feedback/GetFeedback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestFeedbackGetFeedbackGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestFeedbackGetFeedbackGet$Response(params?: ApiRequestFeedbackGetFeedbackGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
    return apiRequestFeedbackGetFeedbackGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestFeedbackGetFeedbackGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestFeedbackGetFeedbackGet(params?: ApiRequestFeedbackGetFeedbackGet$Params, context?: HttpContext): Observable<Feedback> {
    return this.apiRequestFeedbackGetFeedbackGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Feedback>): Feedback => r.body)
    );
  }

  /** Path part for operation `apiRequestFeedbackSavePost()` */
  static readonly ApiRequestFeedbackSavePostPath = '/api/request/feedback/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestFeedbackSavePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackSavePost$Response(params?: ApiRequestFeedbackSavePost$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackApiRespModel>> {
    return apiRequestFeedbackSavePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestFeedbackSavePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestFeedbackSavePost(params?: ApiRequestFeedbackSavePost$Params, context?: HttpContext): Observable<FeedbackApiRespModel> {
    return this.apiRequestFeedbackSavePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackApiRespModel>): FeedbackApiRespModel => r.body)
    );
  }

}
